module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("MoRU3"))).then(() => parcelRequire('iDabs'));